import {setPersistedAtValue} from '../../../actions/raOptimal/persistedAt'

export const raOptimalPersistedAt = (store, next, action) => {
    const result = next(action);
    store.dispatch(setPersistedAtValue());
    return result;
}